export default __webpack_public_path__ + "static/media/icon-depot-end.9e920a8c.svg";